import { render, staticRenderFns } from "./GoodReceipt.vue?vue&type=template&id=60eadbca"
import script from "./GoodReceipt.vue?vue&type=script&lang=js"
export * from "./GoodReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports